import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormatPricePipe } from '@epicuro-next/ataraxia/formatting';

import { SocialFormatterPipe, YoutubeThumbnailPipe } from './pipes';

@NgModule({
  imports: [CommonModule, FormatPricePipe],
  declarations: [YoutubeThumbnailPipe, SocialFormatterPipe],
  exports: [YoutubeThumbnailPipe, SocialFormatterPipe],
})
export class EngagementCommonModule {}
